import * as e from "react";
import a from "../lib/SSRBase.es.js";
import m from "../defs/Heart.es.js";
const r = e.forwardRef((t, o) => /* @__PURE__ */ e.createElement(a, { ref: o, ...t, weights: m }));
r.displayName = "HeartIcon";
const f = r;
export {
  f as Heart,
  r as HeartIcon
};
